import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationStart, Router } from '@angular/router';
import { DialogRef, ModalComponent } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { CountryService } from '../../commonservice/countrylist.service';
import { utilityService } from '../../commonservice/utility.service';
import { AppSettings } from '../../_common/constants/app.constants';
import { CountryDetail } from './countryinformation';
export class CustomModalContext extends BSModalContext {
  public modalData: any;
}
@Component({
  selector: 'app-citylist',
  templateUrl: 'citylist.component.html',
  providers: [Modal, CountryService, utilityService]
})
export class CitylistComponent implements OnInit, ModalComponent<CustomModalContext> {
  model: any = {};
  isMore = false; // For Expanding city list class
  context: CustomModalContext;
  modalData: any;
  countryinfo: CountryDetail;
  preferredCountrycollection = [];
  countrycollection = [];
  appSettings: any;
  countryCode: string = 'MX';
  stateCode: string = 'AGS';
  filteredData$: Observable<any>;
  data$: Observable<any>;
  constructor(
    private router: Router,
    private countryserv: CountryService,
    public utilserv: utilityService,
    public dialog: DialogRef<CustomModalContext>,
    public domSanitizer: DomSanitizer,
    public translate: TranslateService
  ) {
    this.modalData = this.dialog.context.modalData;
    this.countryCode = this.dialog.context.modalData.CountryCode;
    this.stateCode = this.dialog.context.modalData.StateCode;
    this.dialog.context.modalData.next = {};
    this.getcountrylistfromservice();
    this.appSettings = AppSettings;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
  }
  ngOnInit() {}
  // Function will intitated Country List and Save on a session variable going forward will use this for getting Country related information
  getcountrylistfromservice() {
    this.countrycollection = this.countryserv.getCountryListFromLocaleEx();
    let filterstates = this.countrycollection.filter(item => item.CountryCode == this.countryCode)[0].states;
    let filtercities = filterstates.filter(item => item.StateCode == this.stateCode)[0].CityList;
    // following citycollection passed from parent component bcos this componnet useing local DB city collcetion
    if (this.modalData.CityCollection != undefined && this.modalData.CityCollection.length > 0) {
      filtercities = this.modalData.CityCollection;
    }
    this.data$ = Observable.of(filtercities);
    this.filteredData$ = this.data$;
  }
  onkeypress(value) {
    this.filteredData$ = this.data$.map(x => {
      return x.filter(y => {
        return y.Subdivisions.find(city => city.toLowerCase().indexOf(value.toLowerCase()) > -1);
      });
    });
  }
  onSelect(city) {
    this.dialog.context.modalData.next = city;
    this.dialog.close();
  }
  closePopup() {
    this.dialog.close();
  }
  switchClass(object) {
    this.isMore = true;
    if (object.currentTarget.title === 'more') {
      document.getElementById('_content').classList.add('showContent');
      document.getElementById('_content').classList.remove('hideContent');
    } else {
      document.getElementById('_content').classList.add('hideContent');
      document.getElementById('_content').classList.remove('showContent');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_common/countrylist/citylist.component.ts